import React, { useEffect, useState } from "react";
import { Box } from "@mui/material";
import CartLoader from "../../../Helper/Loaders/CartLoader";
import AutoResolvedApexChart from "../../../Charts/Mixed/AutoResolvedApexChart";
import { getSmartAlertsTimeseries } from "../../../Api/SmartAlertsAnalyticsApi";
import { calculateGranularity } from "../../BmsFaults/CommonFunctions";
import { formatDateLabel } from "../../../Helper/Analytics/AnalyticsHelper";
import CODE from "../../../Static/Constants/StatusCodes";

export { AUTO_RESOLVED_SERIES_NAMES } from "../../../Charts/Mixed/AutoResolvedApexChart";

const CHART_HEIGHT = 315;
const EMPTY_FILTERS = [];
const EMPTY_SEARCH_TERM = { selectedDevices: [], selectedSearchColumn: null };

const AutoResolvedChartView = ({
  isSidebarExpanded = false,
  startDate,
  endDate,
  granularity,
  globalFilters = {},
  filters = EMPTY_FILTERS,
  searchTerm = EMPTY_SEARCH_TERM,
  onBarClick,
}) => {
  const [loading, setLoading] = useState(true);
  const [chartData, setChartData] = useState({
    categories: [],
    dateRanges: [],
    autoResolvedData: [],
    manuallyResolvedData: [],
  });

  useEffect(() => {
    if (!startDate || !endDate) return;
    let cancelled = false;
    setLoading(true);

    const resolvedGranularity = (granularity || calculateGranularity(startDate, endDate)).toUpperCase();

    const searchFilters = searchTerm?.selectedDevices?.length > 0 && searchTerm?.selectedSearchColumn
      ? [{ name: searchTerm.selectedSearchColumn, values: searchTerm.selectedDevices }]
      : [];
    const combinedFilters = [...(filters || []), ...searchFilters];

    getSmartAlertsTimeseries(globalFilters, {
      startDate,
      endDate,
      select: ["ResolvedAlertCount"],
      groupBy: ["ResolutionType"],
      granularity: resolvedGranularity,
      ...(combinedFilters.length ? { filters: combinedFilters } : {}),
    }).then((result) => {
      if (cancelled) return;

      const data = result?.responseStatus?.code === CODE.SUCCESS
        ? result.response?.data || []
        : [];

      const dateRanges        = data.map((item) => item.xLabel);
      const categories        = data.map((item) => formatDateLabel(item.xLabel));
      const autoResolvedData  = [];
      const manuallyResolvedData = [];

      data.forEach((item) => {
        const metrics = item.metricsArray || [];
        autoResolvedData.push(metrics.find((m) => m.type === "AutoResolvedCount")?.value ?? 0);
        manuallyResolvedData.push(metrics.find((m) => m.type === "ManualResolvedCount")?.value ?? 0);
      });

      setChartData({ categories, dateRanges, autoResolvedData, manuallyResolvedData });
      setLoading(false);
    }).catch(() => {
      if (!cancelled) setLoading(false);
    });

    return () => { cancelled = true; };
  }, [startDate, endDate, granularity, globalFilters, filters, searchTerm]);

  if (loading) {
    return (
      <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", height: CHART_HEIGHT + 50 }}>
        <CartLoader />
      </Box>
    );
  }

  return (
    <AutoResolvedApexChart
      chartData={chartData}
      isSidebarExpanded={isSidebarExpanded}
      onBarClick={onBarClick}
    />
  );
};

export default AutoResolvedChartView;
